import Shop from "examples/Icons/Shop";
import CustomerSupport from "examples/Icons/CustomerSupport";
import Document from "examples/Icons/Document";

import AnalyticsPage from "layouts/dashboardLayout/pages/Analytics";
import UsersPage from "layouts/dashboardLayout/pages/Users";
import AddUserPage from "layouts/dashboardLayout/pages/AddUser";
import PaymentsPage from "layouts/dashboardLayout/pages/Payments";
import EntitiesPage from "layouts/dashboardLayout/pages/Entities";
import AddEntityPage from "layouts/dashboardLayout/pages/AddEntity";
import MissionsPage from "layouts/dashboardLayout/pages/Missions";
import MissionDetailsPage from "layouts/dashboardLayout/pages/MissionDetails";
import TasksPage from "layouts/dashboardLayout/pages/Tasks";
import LeaderboardsPage from "layouts/dashboardLayout/pages/Leaderboards";
import RequestsPage from "layouts/dashboardLayout/pages/Requests";
import ResourceRequestDetailsPage from "layouts/dashboardLayout/pages/ResourceRequestDetails";
import AirportsTeamPage from "layouts/dashboardLayout/pages/AirportsTeam";
import NonprofitRelationsPage from "layouts/dashboardLayout/pages/NonprofitRelations";
import NotificationsPage from "layouts/dashboardLayout/pages/Notifications";
import PricingPage from "layouts/dashboardLayout/pages/Pricing";
import SignIn from "pages/sign-in";
import SignUp from "pages/sign-up";
import ResetPassword from "pages/reset-password";
import SetNewPassword from "pages/set-new-password";

export const dashboardRoutes = [
  {
    index: true,
    key: "dashboard-analytics",
    element: <AnalyticsPage />,
  },
  {
    path: "pricing",
    key: "pricing",
    element: <PricingPage />,
  },
  {
    path: "analytics",
    key: "analytics",
    element: <AnalyticsPage />,
  },
  {
    path: "users",
    key: "users",
    element: <UsersPage />,
  },
  {
    path: "add-user",
    key: "add-user",
    element: <AddUserPage />,
  },
  {
    path: "payments",
    key: "payments",
    element: <PaymentsPage />,
  },
  {
    path: "entities",
    key: "entities",
    element: <EntitiesPage />,
  },
  {
    path: "add-entity",
    key: "add-entity",
    element: <AddEntityPage />,
  },
  {
    path: "missions",
    key: "missions",
    element: <MissionsPage />,
  },
  {
    path: "missions/:missionId",
    key: "mission-details",
    element: <MissionDetailsPage />,
  },
  {
    path: "tasks",
    key: "tasks",
    element: <TasksPage />,
  },
  {
    path: "leaderboards",
    key: "leaderboards",
    element: <LeaderboardsPage />,
  },
  {
    path: "requests",
    key: "requests",
    element: <RequestsPage />,
  },
  {
    path: "requests/:requestId",
    key: "request-details",
    element: <ResourceRequestDetailsPage />,
  },
  {
    path: "airports-team",
    key: "airports-team",
    element: <AirportsTeamPage />,
  },
  {
    path: "nonprofit-relations",
    key: "nonprofit-relations",
    element: <NonprofitRelationsPage />,
  },
  {
    path: "notifications",
    key: "notifications",
    element: <NotificationsPage />,
  },
];

export const authRoutes = [
  {
    path: "sign-in",
    element: <SignIn />,
  },
  {
    path: "sign-up",
    element: <SignUp />,
  },
  {
    path: "reset-password",
    element: <ResetPassword />,
  },
  {
    path: "set-new-password",
    element: <SetNewPassword />,
  },
];

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Shop size="12px" />,
    route: "/dashboard",
    component: <AnalyticsPage />,
  },
  { type: "title", title: "Authentication", key: "title-authentication" },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <CustomerSupport size="12px" />,
    route: "/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Document size="12px" />,
    route: "/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    icon: <Document size="12px" />,
    route: "/reset-password",
    component: <ResetPassword />,
  },
];

export default routes;
